export const SYNC_OPERATION_STATUSES = Object.freeze({
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
});

export const isSyncOperationStatus = (value) =>
  Object.values(SYNC_OPERATION_STATUSES).includes(value);
